import { Download } from 'lucide-react';

export function ExportButton({ label = 'Export JSON' }: { label?: string }) {
  return (
    <button className="button secondary" type="button">
      <Download size={16} aria-hidden="true" />
      {label}
    </button>
  );
}
